import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import editImg from "../images/edit.png"
import deleteImg from "../images/delete.png"
import { database } from '../firebase';
export default class Testimonials extends Component {
    constructor(props) {
        super(props)
        this.state = {
            skillData: [],
        }
    }
    componentDidMount(){
        this.renderList();
    }
    async  renderList(){
        let dataList=[]
        await database.ref("skills").once('value',function(snapshot){
            snapshot.forEach(
             function(ChildSnapshot){
                dataList.push({
                    key:ChildSnapshot.key,
                    skill:ChildSnapshot.val().skill,
                    skillStatus:ChildSnapshot.val().status,
                    expertise :ChildSnapshot.val().expertise
                })
             }
            )
        })
        this.setState({
            skillData:dataList
        })
    }

    render() {
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <div className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li>Skills</li>
                                </ul>
                                <div className='form-head'>
                                    Skills
                                    <Link to="/newSkill/keyId=0"><button className='addNewBtn btn'> New Skills</button></Link>
                                </div>
                                <div className='table'>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Expertise</th>
                                                <th scope="col">Skill</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.skillData.map((data, i) => {
                                            return (
                                                <tr>
                                                    <th scope="row">{i + 1}</th>
                                                    <td>{data.expertise}</td>
                                                    <td>{data.skill}</td>
                                                    <td>{data.skillStatus}</td>
                                                    <td>
                                                        <Link to={'/newSkill/keyId=' + data.key} params={data.key}>
                                                            <img src={editImg} className='actionIcon' ></img>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/skills.jsx